import { Tag } from 'nhsuk-react-components';
import { SummaryReport } from 'schemas/SummaryReport.schema.ts';
import { Iteration } from 'schemas/Iteration.schema.ts';
import { getIsCurrentSummaryReport } from 'utils/summaryReports.ts';
import { formatStatus, getStatusColour } from 'utils/formattingUtils.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { getIterationDetailsById } from 'utils/iterationUtils.ts';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema.ts';

interface IStatusTagProps {
  report: SummaryReport;
  iteration: Iteration;
  campaign: CampaignConfig;
  isLatestReport: boolean;
}

export default function SummaryReportListStatusTag({
  report,
  iteration,
  campaign,
  isLatestReport,
}: IStatusTagProps) {
  const isCurrentSummaryReport = getIsCurrentSummaryReport(report, iteration);
  const iterationDetails = getIterationDetailsById(campaign, iteration.ID!);

  if (isLatestReport && iterationDetails?.status === ITERATION_STATUS.SENT_TO_NHS_NOTIFY) {
    return (
      <Tag color={getStatusColour(ITERATION_STATUS.SENT_TO_NHS_NOTIFY)}>
        {formatStatus(ITERATION_STATUS.SENT_TO_NHS_NOTIFY)}
      </Tag>
    );
  }

  if (!isCurrentSummaryReport) {
    return <Tag color="grey">Archived</Tag>;
  }

  return (
    <Tag
      color={getStatusColour(
        iterationDetails?.status ?? ITERATION_STATUS.REPORT_READY,
      )}
    >
      {formatStatus(iterationDetails?.status ?? ITERATION_STATUS.REPORT_READY)}
    </Tag>
  );
}
